import React, { useEffect, useState, useContext } from "react";
import "../admin/admin.css";
import { Link, Outlet, useHref, useNavigate, useParams } from "react-router-dom";
import Application from "./StateContext/Application";
import '../Users/pages/innercss.css'
import { host } from '../../path'
import "./sidebar-styles.css";
import "../admin/admin.css";

import {ReleaseFromFinance32,ProjectManagement32,BudgetHeadManagement32, BudgetEstimation32,BankofMaharashtraLogo256, BillApprovals32, CreateDepartment32, CreateEmployee32, CreateRole32, Dashboard32, EditRoles32, EditViewEmp, EmployeeManagement32, logout, Master32, MISReports32, navimg, Profile, Report32, Vadhavan, VadhvanLogo256, VendorManagement32, ProjectDashboard, DemandGeneration } from "../../public/LoginImages/importimages";
const menuImages = {
  Dashboard: Dashboard32,
  "Bill Approvals": BillApprovals32,
  "Employee Management": EmployeeManagement32,
  "MIS Reports": MISReports32,
  Master: Master32,
  Report: Report32,
  "Vendor Management": VendorManagement32,
  "Create Department": CreateDepartment32,
  "Create Role": CreateRole32,
  "Create Employee": CreateEmployee32,
  "Edit View Emp": EditViewEmp,
  "Edit Roles": EditRoles32,
  "Project Dashboard": ProjectDashboard,
  "Demand Approval": DemandGeneration,
  "Budget Estimation":BudgetEstimation32,
  "Budget Head Management":BudgetHeadManagement32,
  "Project Management":ProjectManagement32,
  "Release From Finance":ReleaseFromFinance32,



  
  // 07-10
   
  "Fund Management": "/Fund Management  32 Size.png",
  "Fund Creation": "/Fund Management  32 Size.png",
  "Fund Inward List": "/Fund Management  32 Size.png",
  "Fund Outward List": "/Fund Management  32 Size.png",
 
  "Limit Allocation Management": "/Limit-Allocation-Inward-List-32.png",
  "Limit Allocation Management": "/Limit-Allocation-Inward-List-32.png",
  "Limit Allocation Inward List": "/Limit-Allocation-Inward-List-32.png",
  "Limit Allocation": "/Limit-Allocation-Inward-List-32.png",
 
  "Profile Management": "/Profile 32 size.png",
//  sftp://root@163.227.92.37:22558/home/LiabilityRegisterSystem/frontend/public/Bill%20Management%2032%20size.png
  "Bill Management": "/Bill%20Management%2032%20size.png",
  "Bill Approval": "/Bill%20Management%2032%20size.png",
  "View Bill": "/Bill%20Management%2032%20size.png",
  "Create Bill": "/Bill%20Management%2032%20size.png",
 

  "Work Order Management": "/Work-Order-Management-32.png",
  "Create Work Order": "/Work-Order-Management-32.png",
  "Work Order Inward List": "/Work-Order-Management-32.png",
  "Work Order Outward List": "/Work-Order-Management-32.png",
 
  "Budget Head Management": BudgetHeadManagement32,
  "Budget Head Creation": BudgetHeadManagement32,
  "Budget Head Inward List": BudgetHeadManagement32,
  "Budget Head Outward List": BudgetHeadManagement32,
 
  "Project Management": ProjectManagement32,
  "Create Project": ProjectManagement32,
  "Project Inward List": ProjectManagement32,
  "Project Outward List": ProjectManagement32,
 
  "Budget Estimation": BudgetEstimation32,
  "Add Budget Estimation": BudgetEstimation32,
  "Budget Estimation Inward List": BudgetEstimation32,
  "Budget Estimation Outward List": BudgetEstimation32,
 
  "MIS Reports": "/MIS_Reports--32-Size.png",
  "MIS Report": "/MIS_Reports--32-Size.png",
 
  "Master": "/Master  32 Size.png",
  "object code": "/Master  32 Size.png",
 
  "Report": Report32,
  "Vendor Report": Report32,
  "Work Order Report": Report32,
 
  "Progress Report Management": "/Progress-Report-Management-32.png",
  "Progress Report Inward List": "/Progress-Report-Management-32.png",
  "Progress Report Outward List": "/Progress-Report-Management-32.png",
  "Agency Management": "/Agency-Management-32.png",
  "Agency Registration": "/Agency-Management-32.png",
  "Agency Outward List": "/Agency-Management-32.png",
 
  "User Management": "/User-Management-32.png",
  "Create User": "/User-Management-32.png",
  "Edit/View User": "/User-Management-32.png",
 
  
};
const AdminNavbar = () => {
  const navigate = useNavigate("");
  const statecalls = useContext(Application);
  const { Usermenu } = statecalls;
  const [panel, setpanel] = useState("showpanel");
  let check = localStorage.getItem("Token");

  const [renderdata, SetRenderdata] = useState([]);
  const [loading, setloading] = useState(true)
  const [openMenus, setOpenMenus] = useState({});
  const para = useHref()
  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `.hide-scrollbar::-webkit-scrollbar {display: none;}
        .hide-scrollbar {-ms-overflow-style: none;scrollbar-width: none;}`;
    document.head.appendChild(style);
  }, []);
  useEffect(() => {
    try {
      if (!check) {
        navigate('/adminlogin')
        window.location.href = '/adminlogin'
      }
      getmenu()
    } catch (error) {
      console.error('Error in AdminNavbar useEffect:', error);
    }
  }, [])
  console.log("hii herhere", renderdata.result)
  const getmenu = async () => {
    try {
      const data = await Usermenu();
      SetRenderdata(await data);
      setloading(false);
      if (data) {
        console.log("data", data);
        let validationlink = window.location.pathname
        if (!data || typeof data !== "object") {
          console.error("Invalid data:", data);
          return [];
        }

        const menuArray = Array.isArray(data.result) ? data.result : [];
        console.log("hii, i am here", menuArray);
        let check = menuArray.filter((check) => {

          return (
            check.Link === validationlink
          )
        });
        if (check[0] === undefined) {
          alert('you are not allowed to access this link')
          navigate(data[0].Link)
        }
      }
    } catch (error) {
      console.error('Error in AdminNavbar getmenu:', error);
    }
  }
  const sidepanel = () => {
    if (panel === "showpanel") {
      setpanel("panel");
    } else {
      setpanel("showpanel");
    }
  };
  const showoptions = (e) => {
    try {
      let k = document.getElementById(e.currentTarget.value);
      if (k == null) { return }
      if (k.style.display == 'none') {
        k.style.display = 'block'
      }
      else {
        k.style.display = 'none'
      }
    } catch (error) {
      console.error('Error in AdminNavbar showoptions:', error);
    }

  }
  var audio = new Audio('https://commondatastorage.googleapis.com/codeskulptor-assets/Collision8-Bit.ogg');


  // 02-11 for multiple tab open behaiviour
  // Only one parent menu can be open at a time
const toggleMenu = (menuId) => {
  setOpenMenus((prevState) => {
    // If clicked menu is already open, close it
    if (prevState[menuId]) {
      return {};
    }

    // Otherwise, close previous menu and open clicked menu
    return {
      [menuId]: true,
    };
  });
};
// -------
  // Recursive function to render menu items
  const renderMenu = (menuList, parentId = 0) => {
    return menuList
      .filter((menu) => menu.Summenuid === parentId)
      .map((menu) => {
        const iconSrc = menuImages[menu.Menu_Name] || Dashboard32;
        const hasSubmenus = menuList.some((sub) => sub.Summenuid === menu.Menu_ID);
        const isOpen = openMenus[menu.Menu_ID];
        const isActive = window.location.pathname === menu.Link;


        return (
          <li key={menu.Menu_ID} c className={`sidebar-menu-item ${isActive ? "active" : ""}`}>
            {hasSubmenus ? (
              <div
                onClick={() => toggleMenu(menu.Menu_ID)}
                style={{ cursor: "pointer" }}
                className={`sidebar-menu-link ${isOpen ? "active" : ""}`}
              >
                <img
                  src={iconSrc}
                  alt={menu.Menu_Name}
                  className="sidebar-menu-icon"
                />
                <span className="sidebar-menu-text" >
                  {menu.Menu_Name}
                </span>
                {/* ▼ Arrow that rotates when open */}
                <svg
                  className="sidebar-menu-arrow"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  style={{
                    transform: isOpen ? "rotate(90deg)" : "rotate(0deg)",
                    transition: "transform 0.2s ease",
                    marginLeft: "auto",
                  }}
                >
                  <polyline points="9 18 15 12 9 6" />
                </svg>
              </div>
            ) : (
              <Link
                to={menu.Link}
                className={`sidebar-menu-link ${isActive ? "active" : ""}`}
              >
                <img
                  src={iconSrc}
                  alt={menu.Menu_Name}
                  className="sidebar-menu-icon"
                />
                <span className="sidebar-menu-text">{menu.Menu_Name}</span>
              </Link>
            )}

            {hasSubmenus && openMenus[menu.Menu_ID] && (
              <ul className="sidebar-submenu">
              
                {renderMenu(menuList, menu.Menu_ID)}
              </ul>
            )}
          </li>
        );
      });
  };



  return (
    <>
      <div style={{ display: "flex", minHeight: "100vh" ,alignItems: "stretch", overflow: "hidden",  }}>
        {/* This is sidePanel */}
        <div
          className={panel}
          style={{
            boxShadow: "2px",
            animation: "fadeIn 1s ease-in-out",
             height: "100vh",
            //height: "115vh",// side panelheight
          }}
        >
          <div
            className="sidebar-container hide-scrollbar"
            style={{
              // width: "18.5rem",
              //  //height: "100vh",
              //  flexShrink: 0,       
              // height: "auto",
              // minHeight: "100%",

              // display: "flex",
              // flexDirection: "column",
              // justifyContent: "start",

              // background: 'linear-gradient(to bottom, #044c92 , #0071bc , #022f5a)',
              // border: "none",
              //background: '#0071bc', //Deepk
              // background: 'linear-gradient(to bottom, #044c92 , #022f5a )', //Deepk 
              // background: 'linear-gradient(to bottom, #022f5a , #0071bc )',
              //  background: 'linear-gradient(to bottom, #0071bc , #022f5a )',
      //          position: "fixed",
      // top: 0,
      // left: 0,
      height: "100vh",
      // width: "100%",
      width: "18.5rem" , // ✅ collapsible width
      transition: "width 0.3s ease",
      background: "linear-gradient(to bottom, #044c92 , #0071bc , #022f5a)",
      //  background: "#0071bc",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      // overflowY: "scroll",
      // scrollbarWidth: "none",
      // msOverflowStyle: "none",
      // zIndex: 1000,
             
            }}

          >
            <div
              style={{ textAlign: "center", padding: "10px 0" }}
            >
              <img
                src={VadhvanLogo256}
                className="sidebar-logo"
                alt="..."
                style={{
                  width: "180px",
                  height: "120px",
                  objectFit: "contain",
                }}
              />
            </div>
            <ul className="list-group list-group-flush sidebar-menu-list"
            style={{ border: "none", fontWeight: "600", padding: "0px 10px 0px 15px" }}>
              {loading ? (
                <div className="loader"></div>
              ) : (
                Array.isArray(renderdata.result) ? renderMenu(renderdata.result) : <a key={5678} style={{ color: 'white' }}>Kindly Refresh</a>

              )
              }
<div className="sidebar-logout-container" >
                <Link to='/AdminLogin'>
                  <button onClick={() => localStorage.clear()} className="sidebar-logout-btn">
<img
  src="/Logout.png"
  alt="Logout Icon"
  style={{
    width: "20px",
    height: "20px",
    filter: "brightness(0) invert(1)"
  }}
/>Logout
 
                  </button>
                </Link>
              </div>
            </ul>
            <div
              className="sidebar-bottom-wave"
              style={{
                height: '100px',
                backgroundImage: `url(${"/nav.png"})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                flexShrink: 0
              }}
            ></div>
          </div>
        </div>
        {/* this is navebar */}

        {/* <div style={{ width: "100vw" }}> */}
           <div style={{ width: "auto",minWidth:0,flex:1 }}>
          <nav className="modern-navbar"
            style={{
              backgroundColor: "#ffffff",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "8px 20px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              height: "60px",
              boxShadow: '0px 0px 5px',
              // marginLeft: "18.5rem",
            }} >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <button
                onClick={sidepanel}
                className="hamburger-btn"
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: "8px",
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2">
                  <line x1="3" y1="6" x2="21" y2="6"></line>
                  <line x1="3" y1="12" x2="21" y2="12"></line>
                  <line x1="3" y1="18" x2="21" y2="18"></line>
                </svg>
              </button>
              <div
                className="dashboard-badge"
                style={{
                  background: 'linear-gradient(to bottom, #044c92 , #0071bc , #022f5a )',
                  color: "white",
                  padding: "6px 16px",
                  borderRadius: "5px",
                  fontSize: "14px",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                {/* {para.slice(1)} */}
                {para.split("/")[2] === "ProjectDashboard" ? "Dashboard" :
                  para.split("/")[2] === "DemandGeneration" ? "BillCreationCapital" :
                    para.split("/")[2] === "DemandGenerationForRevenue" ? "BillCreationRevenue" :
                        //  para.split("/")[2] === "CreateEmployee" ? "Create User" :
                      // para.split("/")[2] === "EditViewEmp" ? "Edit/View User": //29-09
                      // 30-09
                        ["CreateProject", "ProjectInwardList", "ProjectList"].includes(para.split("/")[2]) ? "Project Management" :
                          ["BudgetHeadList", "BudgetHeadCreation", "BudgetHeadInwardList"].includes(para.split("/")[2]) ? "Budget Head Management" :
                          [ "BudgetEstimation", "BudgetEstimationInwardList", "BudgetEstimationList"].includes(para.split("/")[2]) ? "Budget Estimation" :
                          ["FundCreation", "FundList", "FundInwardList"].includes(para.split("/")[2]) ? "Fund Management" :
                          ["ECSTransferFiles", "ECSReport"].includes(para.split("/")[2]) ? "ECS Management" :
                          ["LimitAllocation", "LimitAllocationInwardList", "LimitAllocationOutwardList"].includes(para.split("/")[2]) ? "Limit Allocation Management" :
                          ["Banks", "Taxes", "ObjectCode"].includes(para.split("/")[2]) ? "Master" :
                          ["VendorReport", "WorkOrderReport", "LogReports" ].includes(para.split("/")[2]) ? "Report" :
                          ["CreateWorkOrder", "WorkOrderList", "WorkOrderInwardList"].includes( para.split("/")[2]) ? "Work Order Management" :
                          ["BillApprovals", "DemandGeneration", "ViewDemandGeneration"].includes(para.split("/")[2]) ? "Bill Management" :
                          ["ProgresseReportInwordList", "ProgresseReportOutwordList"].includes(para.split("/")[2]) ? "Progress Report Management" :
                          ["CreateVendor", "VendorList"].includes(para.split("/")[2]) ? "Vendor Management" :
                          ["AgencyRegistration", "AgencyOutwardList"].includes(para.split("/")[2])? "Agency Management" :
                          ["CreateEmployee", "EditViewEmp"].includes(para.split("/")[2]) ? "User Management" 
 
                      :para.split("/")[2] || "ProjectDashboard"}
              </div>
              {/* <i className="fa-solid fa-sliders"></i>
              <span style={{ backgroundColor: "rgb(6 79 207)", color: "white", padding: "5px", marginLeft: "5px", border: "1px", border: "none", borderRadius: "8px" }}> {para.slice(1)} </span> */}
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <div><img src={BankofMaharashtraLogo256} /></div>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                height: '2.7rem',
                padding: '10px',
                justifyContent: 'center',
                gap: '0.5rem',
              }}>
                <div style={{ background: '#e5f4fb', outline: '#000', borderRadius: ' 24px', padding: '5px 10px' }}>


                  <img src={Profile} />
                  <span style={{ color: "black" }}>{renderdata ? `Welcome ${renderdata?.Data?.FullName}` : ''}</span>
                </div>
              </div>
            </div>
          </nav>
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default AdminNavbar;


